import {
    forwardRef
} from "react";
import type IBrandIconProps from "./type";
import type {
    BrandIconConfigType,
    BrandIconComponent,
    BrandIconDataType
} from "./type";
import {
    BRAND_ICON_VIEW_BOX,
    BRAND_ICON_SIZE
} from "./constant";
import {
    Path,
    Svg
} from "react-native-svg";

export const createBrandIcon = ({
    viewBox = BRAND_ICON_VIEW_BOX,
    isMultiColor = false,
    renderShape,
    brandColor,
    brandTitle,
    name
}: BrandIconConfigType): BrandIconComponent => {
    const BrandIcon = forwardRef<Svg, IBrandIconProps>(({
        size = BRAND_ICON_SIZE,
        customColor,
        color,
        ...props
    }, ref) => <Svg
        {...props}
        viewBox={viewBox}
        height={size}
        width={size}
        ref={ref}
    >
        {renderShape(customColor ?? color ?? "currentColor")}
    </Svg>);

    BrandIcon.displayName = `${name}BrandIcon`;

    return Object.assign(BrandIcon, {
        isMultiColor,
        brandColor,
        brandTitle
    });
};

export const createMonoBrandIcon = ({
    title,
    name,
    path,
    hex
}: BrandIconDataType): BrandIconComponent => createBrandIcon({
    renderShape: (color) => <Path
        fill={color}
        d={path}
    />,
    brandTitle: title,
    brandColor: hex,
    name
});
